import React from 'react';
import { LabeledStatsContainer } from './LabeledStatsContainer';
import './TrafficAndAlertStatsContainer.scss';

export const TrafficAndAlertStatsContainer = ({
    trafficLastHour,
    trafficTooltipMessage,
    alertsLastHour,
    alertsTooltipMessage
}) => (
    <div className={'traffic-alert-stats-container'}>
        <LabeledStatsContainer
            label={'Traffic'}
            tooltipMessage={trafficTooltipMessage}
        >
            {trafficLastHour && (
                <span className={'content traffic'}>{trafficLastHour}</span>
            )}
        </LabeledStatsContainer>
        <LabeledStatsContainer
            label={'Alerts'}
            tooltipMessage={alertsTooltipMessage}
        >
            {alertsLastHour && (
                <span className={'content alerts'}>{alertsLastHour}</span>
            )}
        </LabeledStatsContainer>
    </div>
);
